import * as angular from "angular";
import {IController, IScope} from "angular";
import {GeofenceLocationType} from "../../models/geofence-zone.model";

export class geofenceZonesListCtrl implements IController {

  featureCollection: any;
  searchQuery: string;
  selectedFeature: any;
  locationType: GeofenceLocationType;
  hasMore: boolean;
  isLoading: boolean;
  onSelect: Function;
  onEdit: Function;
  onDelete: Function;
  onLoadMore: Function;

  emptyStateText: string;
  selectedAreaId: string;

  /* @ngInject */
  constructor(private $anchorScroll, private $scope: IScope) {
  }

  $onInit() {
    this.$scope.$on('anchor-scroll', (event, id) => {
      this.$anchorScroll(id);
    });
  }

  $onChanges(changes) {
    if (changes.locationType) {
      this.emptyStateText = this._getEmptyStateText();
    }
    if (changes.selectedFeature) {
      this.selectedAreaId = this.selectedFeature && this.selectedFeature.properties
        ? this.selectedFeature.properties.areaId
        : null;
    }
  }

  private _getEmptyStateText(): string {
    switch (this.locationType) {
      case GeofenceLocationType.ACCOUNT:
        return 'No Account Service Areas';
      case GeofenceLocationType.DEPOT:
        return 'No Depot Service Areas';
      default:
        return 'No Service Areas';
    }
  }

}

angular
  .module('bringoz.admin.service-areas')
  .component('geofenceZonesList', {
    bindings: {
      featureCollection: '<',
      searchQuery: '<',
      selectedFeature: '<',
      locationType: '<',
      hasMore: '<',
      isLoading: '<',
      onSelect: '&',
      onEdit: '&',
      onDelete: '&',
      onLoadMore: '&'
    },
    template: require('./geofence-zones-list.html').default,
    controller: geofenceZonesListCtrl
  });
